/**
 * @generated SignedSource<<e63abc6a71a948bc949d192f00b0ab80>>
 * @relayHash 819e3cc2bd6c7ac01c1229d099aed61c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 819e3cc2bd6c7ac01c1229d099aed61c

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestTakeOverPatientFileLockInput = {
  appointmentId?: string | null;
  callId?: string | null;
  inboundCallId?: number | null;
  patientId: string;
};
export type useRequestTakeOverPatientMutation$variables = {
  input: RequestTakeOverPatientFileLockInput;
};
export type useRequestTakeOverPatientMutation$data = {
  readonly requestTakeOverPatientFileLock: {
    readonly errors: ReadonlyArray<{
      readonly __typename?: string;
      readonly message?: string;
    }> | null;
    readonly patientFileLockOutput: {
      readonly inContextOfAppointment: {
        readonly chatDetails: {
          readonly chatThreadId: string;
        } | null;
      } | null;
      readonly patientFileLock: {
        readonly lockedBy: string | null;
      };
      readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockOutputFragment">;
    } | null;
  };
};
export type useRequestTakeOverPatientMutation = {
  response: useRequestTakeOverPatientMutation$data;
  variables: useRequestTakeOverPatientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedBy",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentChatDetails",
  "kind": "LinkedField",
  "name": "chatDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatThreadId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRequestTakeOverPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RequestTakeOverPatientFileLockPayload",
        "kind": "LinkedField",
        "name": "requestTakeOverPatientFileLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "type": "Error",
                "abstractKey": "__isError"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLockOutput",
            "kind": "LinkedField",
            "name": "patientFileLockOutput",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientFileLockOutputFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientFileLock",
                "kind": "LinkedField",
                "name": "patientFileLock",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "inContextOfAppointment",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRequestTakeOverPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RequestTakeOverPatientFileLockPayload",
        "kind": "LinkedField",
        "name": "requestTakeOverPatientFileLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*:: as any*/)
                ],
                "type": "Error",
                "abstractKey": "__isError"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLockOutput",
            "kind": "LinkedField",
            "name": "patientFileLockOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientFileLock",
                "kind": "LinkedField",
                "name": "patientFileLock",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "patientId",
                    "storageKey": null
                  },
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockRequestedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockRequestedBy",
                    "storageKey": null
                  },
                  {
                    "alias": "inContextOfAppointment",
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "appointment",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestInContextOfAppointmentId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "inContextOfAppointment",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCompleted",
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "819e3cc2bd6c7ac01c1229d099aed61c",
    "metadata": {},
    "name": "useRequestTakeOverPatientMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cab2116fca5994661252100ca3aad405";

export default node;
